/**
 * AccountSignIn.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    toggleSignInModalOpen: PropTypes.func,
    toggleCreateModalOpen: PropTypes.func

};

export default class AccountSignIn extends React.Component {
    render() {
        return (
            <div>
                <button
                    className="nav-header-button"
                    title="Sign Up"
                    aria-label="Sign Up"
                    onClick={() => this.props.toggleCreateModalOpen()}>
                    Sign Up
                </button>

                <button
                    className="nav-header-button"
                    title="Log In"
                    aria-label="Log In"
                    onClick={() => this.props.toggleSignInModalOpen()}>
                    Log In
                </button>
            </div>
        );
    }
}

AccountSignIn.propTypes = propTypes;
